// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  FEEDS_UNSET_FEEDS,
} from './constants';

export function unsetFeeds() {
  return {
    type: FEEDS_UNSET_FEEDS,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FEEDS_UNSET_FEEDS:
      return {
        ...state,
        news: state.news.clear(),
        pagination: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feeds/redux/unsetFeeds.js